import zhHkConfig from "./zh-hk/index.json";
import zhCnConfig from "./zh-cn/index.json";
import enConfig from "./en/index.json";
import { getLanguage } from "../language";

const langMap = {
  'zh-hk': zhHkConfig,
  'zh-cn': zhCnConfig,
  en: enConfig,
};

/**
 * 获取文案
 * @param text 文案
 */
export function getLocale(text) {
  const lang = getLanguage();
  const textMap = langMap[lang] || langMap['en'];
  return textMap[text];
}
